import React from 'react';
import classnames from 'classnames';
import Loader from '@wix/da-ds/pkg/Loader';
import { useTranslation } from 'react-i18next';
import s from './DropZoneIndicator.scss';

export interface Props {
  className?: string;

  isDraggingEnabled?: boolean;
  isDragActive: boolean;
  isDragReject: boolean;
  isDragAccept: boolean;
}

const DropZoneIndicator: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  isDraggingEnabled = true,
  isDragAccept,
  isDragActive,
  isDragReject,
  children,
}) => {
  const { t } = useTranslation();
  const showDropIndicator = isDragReject || isDragAccept || isDragActive;

  if (!isDraggingEnabled) {
    return children;
  }

  return (
    <div
      className={classnames(
        s['root'],
        isDragAccept && s['accept'],
        isDragActive && s['active'],
        isDragReject && s['reject'],
        className
      )}
    >
      {children}
      {showDropIndicator && (
        <div className={s['dropzone']}>
          <Loader state="static_color" size="big" />
          <div className={s['dragging-title']}>{t('deviationSubmit.dropZone.title')}</div>
        </div>
      )}
    </div>
  );
};
DropZoneIndicator.displayName = 'DropZoneIndicator';

export default DropZoneIndicator;
